import React from "react"
import { Link } from "react-router-dom"
import { Table } from "react-bootstrap"
import styled from "styled-components"
import { getStockInfo, stockProducts } from "../../../../api/stocks"
import LoadingContainer from "../../../../_components/LoadingContainer"
import Button from "../../../../_components/Button"
import LoadingInput from "../../../../_components/LoadingInput"
import * as colors from "../../../../assets/_base/colors"
import Text from "../../../../_components/Text"
import { UpdateStockQuantity } from "../../Products/Product"
import { formatCurrencyValue, showSnackBar } from "../../../../utils"
import Currency from "react-currency-formatter"

const Card = styled.div`
    padding: 10px;
    margin 5px;
    * {
        text-align: center;
    }
`
const L = styled(Link)`
    color: ${colors.darkBlue}
`

export default props => {
    const stocksRef = React.useRef(null)
    const [loading, setLoading] = React.useState(true)
    const [info, setInfo] = React.useState({ positive_stock: {}, negative_stock: {} })
    const [stocks, setStocks] = React.useState([])
    const [stocksParamsSearch, setStocksParamsSearch] = React.useState({})

    function goToHistoryStockItem(product) {
        window.location.href = `/stocks/history/?product=${product}`
    }

    function loadStocks() {
        setStocks([])
        stockProducts(stocksParamsSearch).then(resp => setStocks(resp))
    }
    React.useEffect(loadStocks, [stocksRef.current])

    function onUpQuantity() {
        setTimeout(() => {
            window.location.reload()
        }, 2000)
    }

    function onChange(e) {
        setStocksParamsSearch({
            ...stocksParamsSearch,
            [e.target.name]: e.target.value
        })
    }

    function init() {
        getStockInfo()
            .then(info => {
                setInfo(info)
            })
            .finally(() => {
                window.scrollTo({ top: 0, behavior: "smooth" })
                setTimeout(() => setLoading(false), 100)
            })
    }

    React.useEffect(init, [])

    return <LoadingContainer loading={loading} ref={stocksRef}>
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <Text className="h4">
                        Informações de estoque
                    </Text>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <Card>
                        <h1>
                            Estoque positivo
                        </h1>
                        <Table striped bordered hover variant="success">
                            <thead>
                                <tr>
                                    <th>Itens em estoque</th>
                                    <th>Quantidade em estoque</th>
                                    <th>Valor total do estoque</th>
                                    <th>Custo total do estoque</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {
                                            info.positive_stock.total_items
                                        }
                                    </td>
                                    <td>
                                        {
                                            info.positive_stock.total_quantity
                                        }
                                    </td>
                                    <td>
                                        <Currency symbol="R$ " currency="BRL" quantity={info.positive_stock.value} />
                                    </td>
                                    <td>
                                        <Currency symbol="R$ " currency="BRL" quantity={info.positive_stock.cost} />
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Card>
                </div>
                <div className="col-md-6">
                    <Card>
                        <h1>
                            Estoque negativo
                        </h1>
                        <Table striped bordered hover variant="warning">
                            <thead>
                                <tr>
                                    <th>Itens em estoque</th>
                                    <th>Quantidade em estoque</th>
                                    <th>Valor do estoque</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {
                                            info.negative_stock.total_items
                                        }
                                    </td>
                                    <td>
                                        {
                                            info.negative_stock.total_quantity
                                        }
                                    </td>
                                    <td>
                                        0
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Card>
                </div>
                <div className="col-12 text-center">
                    <L to="/stocks/history">
                        Visualizar movimentação
                    </L>
                </div>
            </div>
            <div className="row my-3">
                <div className="col-12">
                    <Text className="h4">
                        Estoques
                    </Text>
                </div>
                <div className="col-md-4">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                Códido item
                            </Text>
                        </div>
                        <LoadingInput
                            name="code"
                            value={stocksParamsSearch.code}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                Descrição do item
                            </Text>
                        </div>
                        <LoadingInput
                            name="name"
                            value={stocksParamsSearch.name}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                Resultados
                            </Text>
                        </div>
                        <LoadingInput
                            name="end_count"
                            value={stocksParamsSearch.end_count}
                            onChange={onChange}
                            as="select">
                            {
                                [10, 20, 30, 50, 100, 200].map((i, jk) => {
                                    return <option>
                                        {
                                            i
                                        }
                                    </option>
                                })
                            }
                        </LoadingInput>
                    </div>
                </div>
                <div className="col-md-4">
                    <Button onClick={loadStocks}>
                        Filtrar
                    </Button>
                </div>
                <div className="col-12">
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Item</th>
                                <th>Valor do item</th>
                                <th>Quantidade em Estoque</th>
                                <th>Valor do Estoque</th>
                                <th>Custo do estoque</th>
                                <th>Quantidade vendida</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                stocks.map((stock, idx) => {
                                    let quantity = stock.quantity.toFixed(4)
                                    let stockValue = (quantity * stock.product_price).toFixed(4)
                                    let stockCost = (quantity * stock.product_cost).toFixed(4)
                                    return <tr key={`stocks-list-${stock.id}`}>
                                        <td>
                                            {idx + 1}
                                        </td>
                                        <td>
                                            {
                                                stock.product_name
                                            }
                                        </td>
                                        <td>
                                            <Currency symbol="R$ " currency="BRL" quantity={stock.product_price} />
                                        </td>
                                        <td>
                                            {quantity}
                                        </td>
                                        <td>
                                            <Currency symbol="R$ " currency="BRL" quantity={stockValue} />
                                        </td>
                                        <td>
                                            <Currency symbol="R$ " currency="BRL" quantity={stockCost} />
                                        </td>
                                        <td>

                                            {
                                                stock.ordered_quantity
                                            }
                                        </td>
                                        <td>
                                            <UpdateStockQuantity
                                                onSave={onUpQuantity}
                                                data={{
                                                    id: stock.product,
                                                    name: stock.product_name,
                                                    stock_quantity: stock.quantity
                                                }} />
                                            <Button
                                                className="d-block mt-2"
                                                as="text" onClick={() => goToHistoryStockItem(stock.product)}>
                                                Ver Histórico
                                            </Button>
                                        </td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    </LoadingContainer>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Stocks/Info/index.jsx